import { put, takeEvery, select, all } from "redux-saga/effects";
import { authorizedApi } from "tools/apiConfigurator";
import * as actions from "./rootAccountGetActions";
import { setFeatureFlags } from "@p81-common/shell-core-js";
import { setAddonPermissions } from "@p81-common/shell-core-js";
import { PROFILE_ACCOUNT_GET_REQUEST_SUCCESS } from "@p81-common/shell-core-js/dist/redux/accountGet";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";
import { featureFlagUpdateEventName } from "data";
import { setSubscriptionStatus } from "components/billing/helpers";

function* rootAccountGet() {
  try {
    const response = yield authorizedApi.get("account").json();

    yield put(actions.requestSuccess(response.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* setAddonPermissionsSaga(action) {
  // rootAccountGet's own fetch is never sub-tenant-scoped, so its success payload is
  // always genuinely the root account. PROFILE_ACCOUNT_GET_REQUEST_SUCCESS (like
  // CURRENT_CHILD_ORGANIZATION_SET) can instead carry whichever org is currently being
  // viewed — the child's own account while an MSP parent is browsing a child, not the
  // parent's (see accountGetSaga.js's requestWithSubTenantIfNeeded).
  const mayBeChildScoped = action.type !== actions.ROOT_ACCOUNT_GET_REQUEST_SUCCESS;
  const viewingChild =
    mayBeChildScoped &&
    (action.type === CURRENT_CHILD_ORGANIZATION_SET ||
      (yield select((s) => Boolean(s.currentChildOrganization?.subTenantId))));

  const account = viewingChild
    ? yield select((s) => s.rootAccountGet.data?.account)
    : action.data?.account;

  const { permissions = [], featureFlagKeys = [], subscriptionStatus } = account || {};
  setAddonPermissions(permissions);
  setFeatureFlags(featureFlagKeys);
  setSubscriptionStatus(subscriptionStatus);
  window.dispatchEvent(new CustomEvent(featureFlagUpdateEventName));

  // Also refresh the rootAccountGet slice itself once we've confirmed this payload is
  // genuinely the root account — e.g. after a billing mutation (activate/reactivate/
  // cancel/change plan) triggers PROFILE_ACCOUNT_GET_REQUEST_SUCCESS for the root org —
  // so useRootAccount() consumers (Billing.js, sidebar, profile menu) see the fresh
  // plan/subscription immediately instead of staying stale until the next full app load.
  // ROOT_ACCOUNT_GET_REQUEST_SUCCESS is excluded here — re-dispatching itself would loop.
  if (action.type === PROFILE_ACCOUNT_GET_REQUEST_SUCCESS && !viewingChild) {
    yield put(actions.requestSuccess(action.data));
  }
}

function* saga() {
  yield all([
    takeEvery(actions.ROOT_ACCOUNT_GET_REQUEST, rootAccountGet),
    takeEvery(
      [
        actions.ROOT_ACCOUNT_GET_REQUEST_SUCCESS,
        PROFILE_ACCOUNT_GET_REQUEST_SUCCESS,
        CURRENT_CHILD_ORGANIZATION_SET,
      ],
      setAddonPermissionsSaga
    ),
  ]);
}

export default saga;
